import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Informativa Privacy</h1>
          <p className="text-gray-700 mb-8">Informativa resa ai sensi del Regolamento (UE) 2016/679 (GDPR) e del D.Lgs. 196/2003 come modificato. Descrive come trattiamo i dati personali nell’ambito dei servizi offerti su AffittoOnline.it.</p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">Titolare del trattamento</h2>
            <p className="text-gray-700">AffittoOnline.it • Email: <a href="mailto:info@contrattionline.it" className="text-blue-600">info@contrattionline.it</a> • Tel: <a href="tel:+393470088959" className="text-blue-600">+39 3470088959</a>.</p>
            <p className="text-gray-700">Il Titolare non ha nominato un DPO.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">Categorie di dati trattati</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Dati identificativi e di contatto: nome, email, telefono.</li>
              <li>Contenuti forniti volontariamente nei moduli di contatto e prenotazione.</li>
              <li>Dati tecnici di navigazione e utilizzo del sito, in forma aggregata.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">Finalità e basi giuridiche</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Gestione richieste di contatto e consulenza • Base: esecuzione di misure precontrattuali/contratto (art. 6.1.b GDPR).</li>
              <li>Prenotazioni e comunicazioni operative • Base: esecuzione del contratto (art. 6.1.b) e legittimo interesse (art. 6.1.f).</li>
              <li>Adempimenti normativi e fiscali ove applicabili • Base: obbligo legale (art. 6.1.c).</li>
              <li>Attività informative o promozionali su richiesta • Base: consenso (art. 6.1.a), revocabile in ogni momento.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">Conservazione</h2>
            <p className="text-gray-700">I dati di contatto e prenotazione sono conservati per il tempo necessario alla gestione della richiesta e fino a 24 mesi, salvo obblighi di legge diversi. I dati fiscalmente rilevanti seguono i termini di conservazione previsti dalla normativa.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">Destinatari e trasferimenti</h2>
            <p className="text-gray-700">I dati possono essere trattati da fornitori di servizi funzionali all’erogazione del servizio (es. piattaforme di calendario, email, hosting). Qualora si verifichino trasferimenti extra-UE, verranno adottate garanzie adeguate (es. Clausole Contrattuali Standard) secondo il GDPR.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">Diritti dell’interessato</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Accesso, rettifica, cancellazione, limitazione, portabilità, opposizione.</li>
              <li>Per esercitare i diritti: <a href="mailto:info@contrattionline.it" className="text-blue-600">info@contrattionline.it</a>.</li>
              <li>Reclamo al Garante Privacy: <a href="https://www.gpdp.it" className="text-blue-600" target="_blank" rel="noreferrer">www.gpdp.it</a>.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">Cookie</h2>
            <p className="text-gray-700">Il sito utilizza cookie tecnici necessari al funzionamento e, ove presenti, cookie analitici in forma aggregata. Le preferenze possono essere gestite dalle impostazioni del browser.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">Sicurezza e aggiornamenti</h2>
            <p className="text-gray-700">Adottiamo misure tecniche e organizzative adeguate alla protezione dei dati. La presente informativa può essere aggiornata; eventuali modifiche saranno pubblicate su questa pagina.</p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}